import { styled } from 'stitches.config'

export const StepRoot = styled('div', {
  maxWidth: '300px',
  margin: '0 auto',
})
